// src/constants/examDocuments.js
//
// Documentele examenului practic, generate de backend din rezervarea de examen:
//  - „Borderou": documentul elevului pentru o rezervare
//    (GET /practical-exam-slots/documents/individual/{reservationId});
//    buton în popup-ul rezervării și în profilul elevului (Examen → Practic).
//  - „Procesul-verbal al zilei": toate rezervările zilei
//    (GET /practical-exam-slots/documents/daily-process-verbal?date=YYYY-MM-DD);
//    se descarcă apăsând segmentul zilei în calendarul de examen practic.
// Comutator unic: pe `false` butoanele dispar din interfață, codul rămâne.

export const EXAM_DOCUMENTS_ENABLED = true;
